export function mapEvnsToRows(apiList) {
  return (Array.isArray(apiList) ? apiList : []).map((item, idx) => ({
    id: idx,
    evn: item?.EVN ?? '',
    trainNumber: item?.TrainNumber ?? '',
    createdOn: item?.CreatedOn ?? null,
  }));
}

export function getUniqueEvnOptions(rows) {
  return [...new Set(rows.map(r => r.evn))].filter(Boolean);
}

export function getUniqueTrainNumberOptions(rows) {
  return [...new Set(rows.map(r => r.trainNumber))].filter(Boolean);
}
